/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    shape, bool, object, number, string, func, arrayOf,
} from 'prop-types';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';

import Form from '../../Form';
import { form as FormStyle } from '../../../style/form';
import { isEmpty } from '../../../utils/object';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import { isArrayIdIncludes } from '../../../utils/array';
import InputsByLocation from '../AddressConfig/InputsByLocation';
import InputSchema from '../AddressConfig/InputSchema';

import Divider from '../../Divider';
import PhoneMask from '../InputMask/PhoneMask';
import configENV from '../../../config';
import { countryISOAlfa3Codes } from '../../../state/constants/Countries';
import { getFeatureFlags } from '../../../utils/featureSelectors';

const { PERSIST_KEY } = configENV;

const styles = ({ typography, palette }) => FormStyle(typography, palette);

class DesktopBillingEditAdress extends Form {
    state = {
        data: {
            firstname: '',
            lastname: '',
            relationship: '0',
            location: 'Residence',
            company: '',
            street: '',
            apt: '',
            apofpo: 'APO',
            city: '',
            state: '',
            zipcode: '',
            country: 'US',
            phone: '',
            isbilling: false,
            suggestedAddress: 0,
        },
        replaceMask: {
            phone: '[\\D]',
            zipcode: '*',
        },
        replaceMaskWith: {
            phone: '',
            zipcode: 'toUpperCase',
        },
        prevLocation: '',
        prevCity: '',
        prevCityAPO: '',
        prevState: '',
        prevStateAPO: '',
        inputConfig: {},
        errors: {},
        confirmAddress: false,
        selectedSearchAddress: false,
        showSuggestedDropdown: false,
        isVerificationNeeded: true,
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount = () => {
        const {
            addNewConfig,
        } = this.props;
        this.schema = { ...InputSchema[addNewConfig] };
        const confirmAddress = false;
        const selectedSearchAddress = false;
        const showSuggestedDropdown = false;
        const isVerificationNeeded = true;
        // Initialize state
        this.setState({
            inputConfig: InputsByLocation[addNewConfig], confirmAddress, selectedSearchAddress, showSuggestedDropdown, isVerificationNeeded,
        });
        const {
            AddressId,
            recipient,
            recipient: { Addresses },
            locations,
            relationships,
        } = this.props;
        const { data } = this.state;
        if (addNewConfig === 'BillingForm') {
            data.isbilling = true;
        }

        if (isEmpty(recipient) || (addNewConfig !== 'GiftListRecipientForm' && !Addresses) || !this.state.inputConfig || !this.schema) {
            this.setState({ data });
            return;
        }
        const addressesById = Addresses.filter((a) => a.AddressId === AddressId);
        if (!addressesById.length) {
            this.setState({ data });
            return;
        }

        data.firstname = recipient.FirstName;
        data.lastname = recipient.LastName;
        data.relationship = this.getRelationship(
            relationships,
            recipient.RelationShip,
        );
        data.phone = recipient.PhoneNumber ? recipient.PhoneNumber.trim().replace(/[\D]/g, '') : '';
        data.location = isArrayIdIncludes(
            locations,
            addressesById[0].AddressType,
        )
            ? addressesById[0].AddressType
            : 'Residence';
        data.company = recipient.EmployerName ? recipient.EmployerName : '';
        data.street = addressesById[0].AddressLineOne;
        data.apt = addressesById[0].AddressLineTwo;
        data.city = addressesById[0].City;
        data.state = addressesById[0].StateProvince;
        data.zipcode = addressesById[0].PostalCode;
        if (addressesById[0].IsBillingAddress !== undefined) {
            data.isbilling = addressesById[0].IsBillingAddress;
        }
        // TODO: need to default country to US if it's a number value
        data.country = addressesById[0].Country;

        let { prevState, prevStateAPO, prevLocation } = this.state;
        prevLocation = data.location;
        if (data.location === 'APO/FPO') {
            prevStateAPO = data.state;
        } else {
            prevState = data.state;
        }
        data.suggestedAddress = 0;
        this.setState({
            data, prevState, prevStateAPO, prevLocation,
        });
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps = (props) => {
        const { selectedAddress, searchResults, isAddressVerification } = props;
        const { selectedSearchAddress, confirmAddress, isVerificationNeeded } = this.state;
        if (!isEmpty(selectedAddress) && selectedSearchAddress) {
            const { data, errors } = this.state;
            data.street = selectedAddress.street;
            data.apt = selectedAddress.apt;
            data.city = selectedAddress.city;
            data.state = selectedAddress.state;
            data.zipcode = selectedAddress.zipcode;
            data.country = selectedAddress.country;
            delete errors.street;
            delete errors.city;
            delete errors.state;
            delete errors.zipcode;
            this.setState({ data, errors, selectedSearchAddress: false }, () => {
                if (!isVerificationNeeded) {
                    this.handleKeepAddressClicked();
                }
            });
        } else if (isAddressVerification && !confirmAddress && isVerificationNeeded) {
            const hasAddress = this.hasSuggestedAddress(searchResults);
            if (hasAddress) {
                // Keep Address
                this.setState({ isVerificationNeeded: false }, () => {
                    this.handleKeepAddressClicked();
                });
            } else {
                this.setState({ confirmAddress: true });
            }
        }
    };

    getRelationship = (relationships, RelationShip) => {
        let id = '0';
        relationships.forEach((relationship) => {
            if (relationship.id === RelationShip) {
                id = RelationShip;
            }
        });
        return id;
    };

    handleLocationChanged = (dataChanged) => {
        const data = { ...dataChanged };
        let { prevLocation } = this.state;
        const { prevState, prevStateAPO } = this.state;
        if (data.location === 'APO/FPO') {
            data.state = prevStateAPO;
            data.city = data.apofpo;
            const errors = {};
            if (!data.state) {
                errors.state = 'Required field';
            }
            this.setState({ data, errors });
        }
        if (data.location !== 'APO/FPO' && prevLocation === 'APO/FPO') {
            data.city = '';
            data.state = prevState;
            const errors = {};
            errors.city = 'Required field';
            if (!data.state) {
                errors.state = 'Required field';
            }
            this.setState({ data, errors });
        }
        prevLocation = data.location;
        this.setState({ prevLocation });
    };

    handleAPOFPOChanged = (dataChanged) => {
        const data = { ...dataChanged };
        data.city = data.apofpo;
        this.setState({ data });
    };

    handleStateChanged = (dataChanged) => {
        const data = { ...dataChanged };
        let { prevState, prevStateAPO } = this.state;
        if (data.location === 'APO/FPO') {
            prevStateAPO = data.state;
        } else {
            prevState = data.state;
        }
        this.setState({ prevState, prevStateAPO });
    };

    handleCountryChanged = (dataChanged) => {
        const data = { ...dataChanged };
        data.location = 'Residence';
        data.state = '';
        data.zipcode = '';
        const errors = {
            state: 'Required field',
            zipcode: 'Required field',
        };
        if (data.city === 'APO' || data.city === '') {
            data.city = '';
            errors.city = 'Required field';
        }
        this.setState({ data, errors });
    };

    hasSuggestedAddress = (newSearchResults) => {
        let isSuggested = true;
        const { data } = this.state;
        const { selectedAddress, searchResults } = this.props;
        if (!isEmpty(selectedAddress)) {
            // Compare every input field with the selectedAddress
            Object.keys(selectedAddress).forEach((item) => {
                if (selectedAddress[item] !== data[item]) {
                    isSuggested = false;
                }
            });
        } else {
            isSuggested = false;
        }
        const fullAddress = this.getFullAddressString();
        const suggestedList = !isEmpty(newSearchResults) ? newSearchResults : searchResults;
        if (!isEmpty(suggestedList)) {
            // Compare full address with the suggestedList
            suggestedList.forEach((item) => {
                if (item.suggestion === fullAddress) {
                    isSuggested = true;
                }
            });
        }
        return isSuggested;
    };

    doSubmit = (submitData) => {
        const {
            addNewConfig,
            recipient: { occasionId: occasionIdRecipient, orderItemId },
            occasionId,
            currentPage,
            recipient,
            searchError,
            featureFlags,
            billingAddress,
        } = this.props;
        const { data, confirmAddress, isVerificationNeeded } = this.state;
        const isMyAccountQasOn = featureFlags?.['is-my-account-qas-on'] || false;
        const qasError = searchError?.Message?.length > 0 || false;
        const { AddressId, AddressBookEntryId } = submitData;
        const recipientData = {
            addressEntry: {
                FirstName: data.firstname,
                LastName: data.lastname,
                EmployerName: data.company,
                NickName: data.firstname,
                RelationShip: data.relationship,
                PhoneNumber: data.phone ? data.phone : undefined,
            },
            address: {
                AddressType: data.location,
                AddressLineOne: data.street,
                AddressLineTwo: data.apt,
                City: data.city,
                StateProvince: data.state,
                PostalCode: data.zipcode,
                Country: data.country,
                IsBillingAddress: data.isbilling,
            },
        };
        if (isMyAccountQasOn && !qasError && !confirmAddress && isVerificationNeeded && !this.hasSuggestedAddress()) {
            // Confirm address layout
            this.verifyAddress();
        } else {
            this.setState({ isVerificationNeeded: false }, () => {
                submitData.handleSubmitAddNewRecipient(
                    recipientData,
                    AddressId,
                    AddressBookEntryId,
                    addNewConfig,
                    (occasionId || occasionIdRecipient),
                    orderItemId,
                    currentPage,
                    recipient,
                    billingAddress,
                );
            });
        }
    };

    getFullAddressString = () => {
        const { data } = this.state;
        let fullAddress = data.street;
        if (data.apt && data.apt.trim()) {
            fullAddress += ` ${data.apt.trim()}, `;
        } else {
            fullAddress += ', ';
        }
        if (data.city && data.city.trim()) {
            fullAddress += `${data.city.trim()} `;
        }
        if (data.state) {
            fullAddress += `${data.state} `;
        }
        if (data.zipcode) {
            fullAddress += data.zipcode;
        }
        return fullAddress;
    };

    verifyAddress = () => {
        const { data } = this.state;
        const isoCountryCode = countryISOAlfa3Codes[data.country];
        const params = {
            query: this.getFullAddressString(),
            country: isoCountryCode,
            take: 20,
        };
        this.props.handleVerifyAddress(params);
    };

    showSuggestions = () => {
        const { data, showSuggestedDropdown } = this.state;
        const { searchResults } = this.props;
        if (!isEmpty(searchResults) && data.street && data.street.length > 3 && showSuggestedDropdown) {
            return (
                <div className="suggested-address-wrapper">
                    <div className="suggested-address">{
                        searchResults.map((address) => (
                            <MenuItem
                                key={address.suggestion}
                                onClick={() => this.handleSelectAnAddress(address)}
                            >
                                {address.suggestion}
                            </MenuItem>
                        ))
                    }
                    </div>
                </div>
            );
        }
        return null;
    }

    handleSelectAnAddress = (address) => {
        this.setState({ selectedSearchAddress: true }, () => {
            this.props.handleSelectAnAddress(address);
        });
    }

    handleStreetKeyPress = (input) => {
        const { data, showSuggestedDropdown } = this.state;
        const street = input.value;
        // Show suggested address when user used tab key
        if (!showSuggestedDropdown) {
            this.setState({ showSuggestedDropdown: true });
        }
        if (street.length > 3 && street.trim()) {
            const isoCountryCode = countryISOAlfa3Codes[data.country];
            const params = {
                query: street,
                country: isoCountryCode,
                take: 7,
            };
            this.props.handleSearchAddress(params);
        }
    };

    hideSuggestedAddress = () => {
        this.setState({ showSuggestedDropdown: false });
    };

    showSuggestedAddress = (input) => {
        const { showSuggestedDropdown } = this.state;
        if (!showSuggestedDropdown) {
            this.setState({ showSuggestedDropdown: true }, () => {
                this.handleStreetKeyPress(input);
            });
        }
    };

    addressFormLayout = () => {
        const {
            isReadyState, classes, handleSubmitAddNewRecipient, handleCloseModal,
        } = this.props;
        let { locations } = this.props;
        const {
            AddressId,
            recipient,
            states,
            countries,
            AddressBookEntryId,
        } = this.props;
        const { APOFPO, relationships } = this.props;
        const { data, inputConfig, confirmAddress } = this.state;
        let submitButtonLabel = '';
        if (isEmpty(recipient)) {
            submitButtonLabel = isReadyState
                ? ''.concat('Save ')
                : 'Saving...';
        } else {
            submitButtonLabel = isReadyState
                ? ''.concat('Save ')
                : 'Saving...';
        }
        let stateByAddressType = states[data.country].filter((s) => s.id !== 'AA' && s.id !== 'AE' && s.id !== 'AP');
        if (data.location === 'APO/FPO' && data.country === 'US') {
            stateByAddressType = states[data.country].filter((s) => s.id === 'AA' || s.id === 'AE' || s.id === 'AP');
        }
        let inputLabels = {};
        if (Object.keys(inputConfig).indexOf(data.location) > -1) {
            inputLabels = inputConfig[data.location];
        } else {
            inputLabels = inputConfig.default;
        }

        const inputLabelsByCountry = {};
        inputLabelsByCountry.state = 'State';
        inputLabelsByCountry.zipcode = 'Zip Code';
        if (data.country !== 'US') {
            inputLabelsByCountry.state = 'Province';
            inputLabelsByCountry.zipcode = 'Postal Code';
        }
        if (data.country === 'CA') {
            locations = locations.filter((l) => l.id !== 'APO/FPO');
        }

        const zipCodeByCountry = {};
        zipCodeByCountry.type = 'tel';
        zipCodeByCountry.regex = '^[0-9\\-]*$';
        zipCodeByCountry.mask = '';
        if (data.country !== 'US') {
            zipCodeByCountry.type = 'text';
            zipCodeByCountry.regex = '^[0-9\\-a-zA-Z\\s]*$';
        }
        // if (data.country === 'CA') {
        //     zipCodeByCountry.mask = CanadaZipCodeMask;
        // }

        const submitData = {
            AddressId,
            AddressBookEntryId,
            recipient,
            handleSubmitAddNewRecipient,
        };

        const dataTestPrefix = 'my-account-add-address-';
        return (
            <>
                <form
                    onSubmit={(event) => this.handleSubmit(event, submitData)}
                    className={`${classes.form} ${confirmAddress ? 'display-none' : ''}`}
                >
                    <div className="billing-heading margin-bottom">
                        <span>Billing Address</span>
                        <span className="display-inline-block float-right small no-uppercase normal">* Required Field</span>
                    </div>
                    <div className="split">
                        {this.renderInput({
                            name: 'firstname',
                            dataTest: { field: `${dataTestPrefix}${'field-firstname'}`, label: `${dataTestPrefix}${'label-firstname'}` },
                            label: `${inputLabels.firstname.label}*`,
                            type: 'text',
                            pattern: '^[a-zA-Z\\s\\.\\-&]*$',
                            length: 50,
                            desktop: true,
                            onClickHandler: this.hideSuggestedAddress,
                        })}
                        {this.renderInput({
                            name: 'lastname',
                            dataTest: { field: `${dataTestPrefix}${'field-lastname'}`, label: `${dataTestPrefix}${'label-lastname'}` },
                            label: `${inputLabels.lastname.label}*`,
                            type: 'text',
                            pattern: '^[a-zA-Z\\s\\.\\-&]*$',
                            length: 50,
                            desktop: true,
                            onClickHandler: this.hideSuggestedAddress,
                        })}
                        <div className="flex-half" />
                    </div>
                    <div className="split">
                        <div className={inputLabels.relationship.class}>
                            {this.renderSelect({
                                name: 'relationship',
                                label: 'Relationship',
                                options: relationships,
                                desktop: true,
                                onClickHandler: this.hideSuggestedAddress,
                            })}
                        </div>
                        <div className={inputLabels.location.class}>
                            {this.renderSelect({
                                name: 'location',
                                label: 'Location Type',
                                options: locations,
                                desktop: true,
                                onChangeHandler: this.handleLocationChanged,
                                onClickHandler: this.hideSuggestedAddress,
                            })}
                        </div>
                    </div>
                    <div className="split">
                        <div className={`${inputLabels.company.class}`}>
                            {this.renderInput({
                                name: 'company',
                                dataTest: { field: `${dataTestPrefix}${'field-company'}`, label: `${dataTestPrefix}${'label-company'}` },
                                label: inputLabels.company.label,
                                type: 'text',
                                length: 100,
                                adornment: '',
                                desktop: true,
                                onClickHandler: this.hideSuggestedAddress,
                            })}
                        </div>
                        {this.renderInput({
                            name: 'street',
                            dataTest: { field: `${dataTestPrefix}${'field-street'}`, label: `${dataTestPrefix}${'label-street'}` },
                            label: `${inputLabels.street.label}*`,
                            type: 'text',
                            length: 100,
                            autoComplete: 'disabled',
                            desktop: true,
                            onKeyupHandler: this.handleStreetKeyPress,
                            onClickHandler: this.showSuggestedAddress,
                        })}
                        <div className="flex-half">
                            {this.renderInput({
                                name: 'apt',
                                label: inputLabels.apt.label,
                                dataTest: { field: `${dataTestPrefix}${'field-apt'}`, label: `${dataTestPrefix}${'label-apt'}` },
                                type: 'text',
                                length: 20,
                                autoComplete: 'disabled',
                                desktop: true,
                                onClickHandler: this.hideSuggestedAddress,
                            })}
                        </div>
                    </div>
                    {this.showSuggestions()}
                    <div className="split">
                        <div className={inputLabels.apofpo.class}>
                            {this.renderSelect({
                                name: 'apofpo',
                                label: 'APO/FPO',
                                options: APOFPO,
                                desktop: true,
                                onChangeHandler: this.handleAPOFPOChanged,
                                onClickHandler: this.hideSuggestedAddress,
                            })}
                        </div>
                        <div className={`${inputLabels.city.class} cityField`}>
                            {this.renderInput({
                                name: 'city',
                                dataTest: { field: `${dataTestPrefix}${'field-city'}`, label: `${dataTestPrefix}${'label-city'}` },
                                label: `${inputLabels.city.label}*`,
                                type: 'text',
                                pattern: '^[a-zA-Z\\s\\.\\-]*$',
                                length: 50,
                                autoComplete: 'disabled',
                                desktop: true,
                                onClickHandler: this.hideSuggestedAddress,
                            })}
                        </div>
                        {this.renderSelect({
                            name: 'state',
                            label: `${inputLabelsByCountry.state}*`,
                            options: stateByAddressType,
                            onChangeHandler: this.handleStateChanged,
                            useIDAsLabel: true,
                            desktop: true,
                            onClickHandler: this.hideSuggestedAddress,
                        })}
                        <div className="zipCode flex-half">
                            {this.renderInput({
                                name: 'zipcode',
                                dataTest: { field: `${dataTestPrefix}${'field-zipcode'}`, label: `${dataTestPrefix}${'label-zipcode'}` },
                                label: `${inputLabelsByCountry.zipcode}*`,
                                type: zipCodeByCountry.type,
                                pattern: zipCodeByCountry.regex,
                                length: 10,
                                mask: zipCodeByCountry.mask,
                                autoComplete: 'disabled',
                                desktop: true,
                                onClickHandler: this.hideSuggestedAddress,
                            })}
                        </div>
                    </div>

                    <div className="split">
                        {this.renderSelect({
                            name: 'country',
                            label: 'Country*',
                            options: countries,
                            desktop: true,
                            onChangeHandler: this.handleCountryChanged,
                            onClickHandler: this.hideSuggestedAddress,
                        })}
                        <div className={inputLabels.phone.class}>
                            {this.renderInput({
                                name: 'phone',
                                dataTest: { field: `${dataTestPrefix}${'field-phone'}`, label: `${dataTestPrefix}${'label-phone'}` },
                                label: `${inputLabels.phone.label}*`,
                                type: 'tel',
                                pattern: '^[0-9]*$',
                                length: null,
                                adornment: inputLabels.phone.optional ? 'Optional' : '',
                                mask: PhoneMask,
                                desktop: true,
                                onClickHandler: this.hideSuggestedAddress,
                            })}
                        </div>
                        <div className="flex-half" />
                    </div>
                    <div className="margin-top-2x">
                        <div className="buttonForm">
                            {this.renderButton({
                                label: submitButtonLabel,
                                dataTest: { field: `${dataTestPrefix}${submitButtonLabel.split(' ').join('-').toLowerCase()}` },
                                onClick: null,
                                type: 'submit',
                                className: '',
                            })}
                            {this.renderButton({
                                label: 'Cancel',
                                onClick: () => handleCloseModal(true),
                                type: 'button',
                                isValidated: false,
                                className: 'secondary',

                            })}
                        </div>
                    </div>
                </form>
            </>
        );
    };

    confirmationLayout = () => {
        const { data, confirmAddress, isVerificationNeeded } = this.state;
        const { searchResults } = this.props;
        if (!confirmAddress) return null;

        const isoCountryCode = countryISOAlfa3Codes[data.country];
        const address = <div className="bold margin-top-2x margin-bottom-2x"><div>{data.street} {data.apt}</div><div>{data.city}, {data.state} {data.zipcode}</div><div>{isoCountryCode}</div></div>;
        const suggestedList = [];
        if (!isEmpty(searchResults)) {
            searchResults.forEach((item, index) => {
                suggestedList.push({ id: index, name: item.suggestion });
            });
        }
        let textInfo = isEmpty(suggestedList) ? (<p className="margin-top">We could not find a match to the address:</p>) : '';
        textInfo = !isVerificationNeeded ? (<p className="margin-top">You have selected address:</p>) : textInfo;
        let textOptions = isEmpty(suggestedList) ? (<p className="">Please choose one of the options below to proceed</p>) : '';
        textOptions = isVerificationNeeded ? textOptions : '';
        return (
            <>
                <div className={`address-verify billingEditAddress ${!confirmAddress ? 'display-none' : ''}`}>
                    <h2 className="margin-top-2x margin-bottom-2x">Address Verification</h2>
                    {textInfo}
                    {!isEmpty(suggestedList) ? (
                        <>
                            <p className="margin-bottom-2x">According to the USPS&reg; the street number you entered is either missing or incorrect. Please refer to the list of options below.</p>
                            <p className="h2 no-margin-bottom">Choose Recommended Address Below:</p>
                            <div className="align-center">
                                {this.renderSelect({
                                    name: 'suggestedAddress',
                                    label: '',
                                    options: suggestedList,
                                    onChangeHandler: this.handleLocationChanged,
                                    onClickHandler: this.hideSuggestedAddress,
                                })}
                                <div className="margin-top-2x">
                                    <Button
                                        variant="contained"
                                        className="buttonVerify secondary float-none"
                                        onClick={() => this.handleChooseSeletedAddress(searchResults)}
                                    >
                                        Choose Address
                                    </Button>
                                </div>
                            </div>
                            <Divider text="or" />
                            <p className="bold margin-top h2">Keep or edit original address:</p>
                        </>
                    ) : ''}
                    {address}
                    {textOptions}
                    <div className="buttonForm buttons-wrapper">
                        <Button
                            variant="contained"
                            className={` ${isVerificationNeeded ? 'red width-auto' : ''}`}
                            onClick={() => this.handleEditAddressClicked()}
                        >
                            {!isVerificationNeeded ? 'Saving Address...' : 'Edit Address'}
                        </Button>
                        <Button
                            variant="contained"
                            className={`outline width-auto secondary ${!isVerificationNeeded ? 'display-none' : ''}`}
                            onClick={() => this.handleKeepAddressClicked()}
                        >
                            Keep Address
                        </Button>
                    </div>
                </div>
            </>
        );
    };

    handleEditAddressClicked = () => {
        const { data } = this.state;
        data.suggestedAddress = 0;
        this.props.handleSetVerificationState(false);
        this.setState({ data, confirmAddress: false, isVerificationNeeded: true });
    };

    handleKeepAddressClicked = () => {
        const {
            AddressId, AddressBookEntryId, recipient, handleSubmitAddNewRecipient,
        } = this.props;
        const { data } = this.state;
        data.suggestedAddress = 0;
        const submitData = {
            AddressId,
            AddressBookEntryId,
            recipient,
            handleSubmitAddNewRecipient,
        };
        this.setState({ data, isVerificationNeeded: false }, () => {
            this.doSubmit(submitData);
        });
    };

    handleChooseSeletedAddress = (searchResults) => {
        const { suggestedAddress } = this.state.data;
        if (!isEmpty(searchResults) && searchResults[suggestedAddress].format) {
            const address = searchResults[suggestedAddress];
            // Get select address and submit data
            this.setState({ isVerificationNeeded: false }, () => {
                this.handleSelectAnAddress(address);
            });
        }
    };

    render() {
        const { inputConfig } = this.state;
        if (!inputConfig) return null;
        return (
            <>
                {this.addressFormLayout()}
                {this.confirmationLayout()}
            </>
        );
    }
}

DesktopBillingEditAdress.defaultProps = {
    AddressId: undefined,
    AddressBookEntryId: undefined,
    addNewConfig: '',
    recipient: {},
    locations: [],
    states: {},
    countries: [],
    APOFPO: [],
    relationships: [],
    selectedAddress: {},
    searchResults: [],
    searchError: { Message: '' },
    featureFlags: {},
    handleSubmitAddNewRecipient: () => {},
    handleSearchAddress: () => {},
    isAddressVerification: false,
};

DesktopBillingEditAdress.propTypes = {
    classes: object.isRequired,
    isReadyState: bool.isRequired,
    AddressId: number,
    AddressBookEntryId: string,
    recipient: shape({
        AddressBookEntryId: string,
        ContactId: number,
        FirstName: string,
        LastName: string,
        RelationShip: string,
        NickName: string,
        LastUpdateDate: string,
        PhoneNumber: string,
        EmployerName: string,
        NumberOfAddresses: number,
        Addresses: arrayOf(
            shape({
                AddressId: number,
                AddressBookEntryId: string,
                AddressType: string,
                AddressLineOne: string,
                AddressLineTwo: string,
                City: string,
                StateProvince: string,
                PostalCode: string,
                Country: string,
                IsPartialMatch: bool,
                IsUnknownAddress: bool,
                Latitude_degrees: number,
                Longitude_degrees: number,
                IsBillingAddress: bool,
                ContactId: number,
            }),
        ),
    }),
    locations: arrayOf(
        shape({
            id: string,
            name: string,
        }),
    ),
    states: object, // constant pages/state/constants/States.js
    selectedAddress: object,
    countries: arrayOf(
        shape({
            id: string,
            name: string,
        }),
    ),
    // constant pages/state/constants/APOFPO.js
    APOFPO: arrayOf(
        shape({
            id: string,
            name: string,
        }),
    ),
    // constant pages/state/constants/Relationships.js
    relationships: arrayOf(
        shape({
            id: string,
            name: string,
        }),
    ),
    addNewConfig: string,
    handleSubmitAddNewRecipient: func,
    handleSearchAddress: func,
    isAddressVerification: bool,
    featureFlags: object,
};

const mapStateToProps = (state) => {
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    let selectedAddress = {};
    let searchResults = [];
    let searchError = { Message: '' };
    let isAddressVerification = false;
    let featureFlags = {};
    try {
        ({
            selectedAddress, searchResults, searchError, isAddressVerification,
        } = newState.common.addressVerification);
        featureFlags = { ...getFeatureFlags(state) };
    } catch (ex) {
        // continue regardless of error
    }
    return {
        isReadyState: newState.isReadyState,
        AddressId: newState.AddressId,
        AddressBookEntryId: newState.AddressBookEntryId,
        occasionId: newState.giftList.occasionId,
        recipient: newState.recipient,
        locations: newState.locations,
        states: newState.states,
        countries: newState.countries,
        APOFPO: newState.APOFPO,
        relationships: newState.relationships,
        addNewConfig: newState.addNewConfig,
        currentPage: newState.giftList.currentPage,
        featureFlags,
        selectedAddress,
        searchResults,
        searchError,
        isAddressVerification,
        billingAddress: newState.billingAddress,
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleSubmitAddNewRecipient: (data, AddressId, AddressBookEntryId, templateName, occasionId, orderItemId, currentPage, recipient, billingAddress) => dispatch(EventDispatcher.handleSubmitAddNewRecipient(
        data,
        AddressId,
        AddressBookEntryId,
        templateName,
        occasionId,
        orderItemId,
        currentPage,
        recipient,
        billingAddress,
    )),
    handleSearchAddress: (params) => dispatch(EventDispatcher.handleSearchAddress(params)),
    handleVerifyAddress: (params) => dispatch(EventDispatcher.handleVerifyAddress(params)),
    handleSetVerificationState: (isVerified) => dispatch(EventDispatcher.handleSetVerificationState(isVerified)),
    handleSelectAnAddress: (address) => dispatch(EventDispatcher.handleSelectAnAddress(address)),
    handleCloseModal: (closeAll) => dispatch(EventDispatcher.handleCloseModal(closeAll)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(styles)(DesktopBillingEditAdress));
